<template>
    <div class="footer">
        <div class="copyright">
            <a href="javascript:;">Copyright © &nbsp;{{$t('companyName')}}</a>
            <a href="javascript:;">{{$t('icp')}}</a>
        </div>
        <Page v-if="isShowPage" :total="page.total" :page-size="page.size" :page-size-opts="pageSizeOptions" show-total show-sizer @on-change="changePage" @on-page-size-change="changePageSize" />
    </div>
</template>

<script>
export default {
    props: {
        isShowPage: {
            type: Boolean,
            default: false
        },
        page: Object,
        pageSizeOptions: {
            type: Array,
            default: () => {
                return [10, 20, 50, 100];
            }
        }
    },
    data() {
        return {};
    },
    methods: {
        // 改变页数
        changePage(page) {
            this.$emit('change-page', page);
        },
        // 改变每页数量
        changePageSize(size) {
            this.$emit('change-page-size', size);
        }
    }
};
</script>
<style lang="less">
.footer {
    position: fixed;
    bottom: 0;
    left: 95px;
    right: 0;
    z-index: 95;
    height: 40px;
    padding-left: 15px;
    display: flex;
    align-items: center;
    background-color: white;
    border-top: 1px solid #e4e4e4;
    a {
        color: rgba(115, 115, 115, 0.5);
    }
    .copyright {
        flex: 1;
    }
}
</style>




// WEBPACK FOOTER //
// src/views/main_components/footer.vue